import {
  configApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { WorkloadClient } from '@internal/workload-api-helper';
import { Grid, Typography } from '@material-ui/core';

import { SelectElement } from 'react-hook-form-mui';
import { CustomTooltip } from '../CustomTooltip';
import { DepartmentInputProps } from '../types';
import { validateQuestion } from '../utils/checks';

export function Department(props: DepartmentInputProps) {
  const configApi = useApi(configApiRef);
  const oauthApi = useApi(microsoftAuthApiRef);
  const workloadClient = new WorkloadClient(configApi, oauthApi);
  return (
    <Grid container style={{ padding: 5 }} justifyContent="space-between">
      <Grid item xs={11}>
        <SelectElement
          name={props.isPfgOrgUnitAvailable ? 'pfg_org_unit' : 'department'}
          id={props.isPfgOrgUnitAvailable ? 'pfg_org_unit' : 'department'}
          label={props.isPfgOrgUnitAvailable ? 'pfg-org-unit' : 'Department'}
          variant="outlined"
          options={props.departments}
          validation={{
            required: props.isPfgOrgUnitAvailable
              ? 'pfg-org-unit is required'
              : 'Department is required',
            validate: async value => {
              return await validateQuestion(
                props.isPfgOrgUnitAvailable ? 'pfg_org_unit' : 'department',
                value,
                props.apiValidation,
                workloadClient,
                false,
                props.apiValidation.isReadyForServerSideValidation,
              );
            },
          }}
          required
          fullWidth
        />
      </Grid>
      <Grid container item xs={1} alignItems="center">
        <CustomTooltip
          detail={
            <Typography variant="body1">
              {props.isPfgOrgUnitAvailable
                ? 'Owning Org Unit for workload.'
                : 'Department your team aligns to within your business unit.'}
            </Typography>
          }
        />
      </Grid>
    </Grid>
  );
}
